import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL, DASHBOARD_EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_ORDER_DETAIL_REPORT_BEGIN,
  REPORTS_FETCH_ORDER_DETAIL_REPORT_SUCCESS,
  REPORTS_FETCH_ORDER_DETAIL_REPORT_FAILURE,
  REPORTS_FETCH_ORDER_DETAIL_REPORT_DISMISS_ERROR,
} from './constants';

export function fetchOrderDetailReport(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_ORDER_DETAIL_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "itemNumber",
        }
      } 
       const doRequest = axios.post(`${API_REQUEST_URL}/getOrderDetailReport`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_ORDER_DETAIL_REPORT_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_ORDER_DETAIL_REPORT_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchOrderDetailReportError() {
  return {
    type: REPORTS_FETCH_ORDER_DETAIL_REPORT_DISMISS_ERROR,
  };
}

export function useFetchOrderDetailReport() {
  const dispatch = useDispatch();

  const { reportsOrderDetailData,reportsOrderDetailTotals,orderDetailSummary,fetchOrderDetailReportPending, fetchOrderDetailReportError } = useSelector(
    state => ({
      reportsOrderDetailData: state.reports.reportsOrderDetailData,
      reportsOrderDetailTotals: state.reports.reportsOrderDetailTotals,
      orderDetailSummary: state.reports.orderDetailSummary,
      fetchOrderDetailReportPending: state.reports.fetchOrderDetailReportPending,
      fetchOrderDetailReportError: state.reports.fetchOrderDetailReportError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchOrderDetailReport(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchOrderDetailReportError());
  }, [dispatch]);

  return {
    reportsOrderDetailData,
    reportsOrderDetailTotals,
    orderDetailSummary,
    fetchOrderDetailReport: boundAction,
    fetchOrderDetailReportPending,
    fetchOrderDetailReportError,
    dismissFetchOrderDetailReportError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_ORDER_DETAIL_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchOrderDetailReportPending: true,
        fetchOrderDetailReportError: null,
      };

    case REPORTS_FETCH_ORDER_DETAIL_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsOrderDetailData: action.data.data,
        reportsOrderDetailTotals: action.data.totals,
        orderDetailSummary: action.data.summary,
        fetchOrderDetailReportPending: false,
        fetchOrderDetailReportError: null,
      };

    case REPORTS_FETCH_ORDER_DETAIL_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchOrderDetailReportPending: false,
        fetchOrderDetailReportError: action.data.error,
      };

    case REPORTS_FETCH_ORDER_DETAIL_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchOrderDetailReportError: null,
      };

    default:
      return state;
  }
}
